export default "__VITE_ASSET__C66CL_qn__"